import { Button } from "../buttons/shadcn-button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle, DialogTrigger } from "../dialogue/radix-dialog";
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from "../form/form";
import { Input } from "../input/input";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import { addHoliday } from "src/redux/api/_hr_attendance.api";
import { toast } from "react-toastify";

const AddHolidaySchema = z.object({
  date: z.string().min(1, "Date is required"),
  occasion: z.string().min(1, "Occasion is required"),
});

type AddHolidayForm = z.infer<typeof AddHolidaySchema>;

export function AddHolidayDialog({children}: {children: React.ReactNode}) {

  const form = useForm<AddHolidayForm>({
    resolver: zodResolver(AddHolidaySchema),
    defaultValues: {
      date: "",
      occasion: "",
    },
  });

  const onSubmit = async (values: AddHolidayForm) => {
    const dateObj = new Date(values.date);
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth() + 1; // months are 0-indexed
    const date = values.date;

    const payload = {
      date,
      month,
      year,
      occasion: values.occasion,
    };

    try {
      const res = await addHoliday(payload);

      console.log(res);

      if(res.message.toLowerCase() === "success") {
        form.reset();
        toast.success("Holiday added successfully");
      };
      
    } catch (error) {
      toast.error("Failed to add Holiday");
      console.error(error);
      return;
    }
  };

  const buttonText = form.formState.isSubmitting ? <span className="loading loading-dots loading-md"></span> : "Add Holiday";

  return (
    <Dialog>
      <DialogTrigger>{children}</DialogTrigger>
      <DialogContent className="sm:max-w-[500px] bg-card">
        <DialogHeader>
          <DialogTitle>Add Holiday</DialogTitle>
          <DialogDescription>
            Fill in the details to add a new holiday.
          </DialogDescription>
        </DialogHeader>

        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-4">
            {/* Date */}
            <FormField
              control={form.control}
              name="date"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Date</FormLabel>
                  <FormControl>
                    <Input type="date" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            {/* Occasion */}
            <FormField
              control={form.control}
              name="occasion"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Occasion</FormLabel>
                  <FormControl>
                    <Input placeholder="e.g. Diwali" {...field} />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <DialogFooter>
              <Button type="submit" disabled={form.formState.isSubmitting}>{buttonText}</Button>
            </DialogFooter>
          </form>
        </Form>
      </DialogContent>
    </Dialog>
  );
}
